import { useRouter } from "next/router";
import { useEffect } from "react";
import { Address } from "@silo/types";
import { useQueryRestrictions } from "./use-query-restrictions";

export const useMaybeBlockUser = (
  account: Address | undefined,
  blockedPath: string
) => {
  const { replace, asPath } = useRouter();
  const { data, error } = useQueryRestrictions(account);

  useEffect(() => {
    if (data && data.isBlocked) {
      if (blockedPath !== asPath) {
        replace(blockedPath);
      }
    }
  }, [data, replace, asPath]);

  useEffect(() => {
    if (error) {
      console.warn("/blocked error received", error);
    }
  }, [error]);
};
